import { Cookies } from 'react-cookie';

import { UserOnObject } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getClientOwners = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('/client-owners/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as UserOnObject[];
};
